import {
  createVIPListResponseSchema,
  createVIPCampaignListResponseSchema,
  createVIPCampaignProductListResponseSchema,
} from 'src/feature/bite/domain'
import z from 'zod'

export const VIPListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  storeID: z.string().nullable(),
  value: z.number().nullable(),
  icon: z.string().nullable(),
  customerCount: z.number().nullable(),
  status: z.number().nullable(),
})

export const VIPListSchemaResponse = createVIPListResponseSchema(VIPListItemSchema.array())

export type VIPListItem = z.infer<typeof VIPListItemSchema>
export type VIPList = z.infer<typeof VIPListSchemaResponse>
export type VIPListResponse = z.infer<typeof VIPListSchemaResponse>

// VIP CAMPAIGN LIST

export const VIPCampaignListItemSchema = z.object({
  id: z.string(),
  campaignID: z.string(),
  campaignName: z.string().nullable(),
  campaignPromoCluster: z.number(),
  status: z.number(),
})

export const VIPCampaignListSchemaResponse = createVIPCampaignListResponseSchema(
  VIPCampaignListItemSchema.array()
)

// VIP CAMPAIGN PRODUCT LIST

export const VIPCampaignProductListItemSchema = z.object({
  // crmId: z.string(),
  // name: z.string(),
  // code: z.string(),
  // category: z.string(),
  // price: z.number(),
  // isSelected: z.boolean(),
  // id: z.string(),
  // brand: z.string().nullable(),
  id: z.string(),
  code: z.string(),
  name: z.string(),
  category: z.string(),
  createdOn: z.string(),
})

export const VIPCampaignProductListSchemaResponse = createVIPCampaignProductListResponseSchema(
  VIPCampaignProductListItemSchema.array()
)

export type VIPCampaignListItem = z.infer<typeof VIPCampaignListItemSchema>
export type VIPCampaignList = z.infer<typeof VIPCampaignListSchemaResponse>
export type VIPCampaignListResponse = z.infer<typeof VIPCampaignListSchemaResponse>

export type VIPCampaignProductListItem = z.infer<typeof VIPCampaignProductListItemSchema>
export type VIPCampaignProductList = z.infer<typeof VIPCampaignProductListSchemaResponse>
export type VIPCampaignProductListResponse = z.infer<typeof VIPCampaignProductListSchemaResponse>

export type VIPCampaignProductListAllItem = z.infer<typeof VIPCampaignProductListItemSchema>
export type VIPCampaignProductListAll = z.infer<typeof VIPCampaignProductListSchemaResponse>
export type VIPCampaignProductListAllResponse = z.infer<typeof VIPCampaignProductListSchemaResponse>
